import React from 'react';
import EditableTable from '../../components/EditableTable';
import { TextField } from '@mui/material';
import DateTimeField from '../../components/DateTimeField';
import DateField from '../../components/DateField'; // Import DateField
import {toLocalDateString, toLocalDateTimeString} from '../../utils/dateUtils';
import MultiSelectField from "../../components/MultiSelectField";

const diseasesList = [
    "PARVOVIRUS",
    "CORONAVIRUS",
    "DISTEMPER",
    "HEPATITIS",
    "LEPTOSPIROSIS",
    "PARAINFLUENZA",
    "BORDETELLA B",
    "RABIA",
    "RINOTRAQUEITIS",
    "CALCIVIRUS",
    "PANLEUCOPENIA",
    "LEUCEMIA"
];

export default function VaccinationsTable({ vaccinations, onVaccinationsChange }) {
    const headers = ['Fecha', 'Enfermedad', 'Marca', 'Nombre', 'Dosis', 'Notas', 'Revacunación'];

    const cellTemplates = {
        date: {
            read: (value) => toLocalDateTimeString(value),
            edit: (value, onChange) => (
                <DateTimeField
                    name="date"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        diseases: {
            read: (value) => (value || ''),
            edit: (value, onChange) => (
                <MultiSelectField
                    items={diseasesList}
                    value={Array.isArray(value) ? value : value.split(', ')}
                    onChange={(v) => onChange(v.filter(Boolean).join(', '))}
                />
            ),
        },
        mark: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        name: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        dose: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        notes: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        renewalDate: {
            read: (value) => (toLocalDateString(value)), // Display only the date part
            edit: (value, onChange) => (
                <DateField
                    name="renewalDate"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
    };

    const getNewRow = () => {
        const utcTime = new Date().toISOString();
        return {
            id: 0,
            date: utcTime,
            diseases: '',
            mark: '',
            name: '',
            dose: '',
            notes: '',
            renewalDate: null,
        };
    };

    return (
        <EditableTable
            headers={headers}
            data={vaccinations}
            onDataChange={onVaccinationsChange}
            cellTemplates={cellTemplates}
            getNewRow={getNewRow}
            title="Vacunas"
        />
    );
}
